module.exports = __webpack_public_path__ + "static/media/manoela-cristina.a3657910.jpeg";